import Phaser from 'phaser';
import { gameConfig } from './game/config';

new Phaser.Game(gameConfig);
